import { GALLERY, SEO_PAGES } from "@/data/site";
import { PageHero, ConversionRow } from "@/components/Shared";
import { Seo } from "@/components/Seo";

const spanClass = {
  tall: "row-span-2",
  wide: "sm:col-span-2",
  normal: "",
};

const Gallery = () => {
  return (
    <div data-testid="gallery-page">
      <Seo title={SEO_PAGES.gallery.title} description={SEO_PAGES.gallery.description} />
      <PageHero
        eyebrow="Gallery"
        title="A look at the Faf's world"
        intro="From freshly bottled juices to beautifully styled event bars — a glimpse of the colour, care and craft behind every product."
        image={GALLERY[0].url}
        imageAlt={GALLERY[0].alt}
      />

      <section className="pb-8">
        <div className="container-px mx-auto max-w-[1400px]">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 auto-rows-[180px] sm:auto-rows-[240px]">
            {GALLERY.map((g, i) => (
              <div
                key={i}
                data-testid={`gallery-item-${i}`}
                className={`img-zoom-wrap relative overflow-hidden rounded-3xl border border-black/5 ${spanClass[g.span]}`}
              >
                <img src={g.url} alt={g.alt} className="img-zoom h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity duration-300 hover:opacity-100" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-py">
        <div className="container-px mx-auto max-w-[1400px]">
          <div className="rounded-[2.5rem] bg-brand-greenDark text-white p-10 lg:p-16 text-center">
            <h2 className="mx-auto max-w-2xl text-3xl sm:text-4xl font-semibold tracking-tight">
              Want to see Faf's at your next event?
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-white/70">
              Follow us for daily inspiration, or reach out to bring the
              freshness to you.
            </p>
            <div className="mt-8 flex justify-center"><ConversionRow testidPrefix="gallery-cta" /></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
